import { useEffect, type ReactNode } from 'react'
import { Navigate } from '@tanstack/react-router'
import { useOnline } from '@/hooks/use-online'
import { failureKind } from '@/lib/api/client'
import { AvailabilityScreen } from './availability-screen'
import { identifySessionUser, useSession } from './use-session'
import { useSessionExpired } from './use-session-expired'
import { PareLoading } from '@/components/pare-loading'

export function AuthGate({ children }: { children: ReactNode }) {
  const online = useOnline()
  const session = useSession()
  const expired = useSessionExpired(session.data?.expiresAt)

  useEffect(() => {
    if (session.data && !expired) identifySessionUser(session.data.user)
  }, [expired, session.data])

  if (!online)
    return (
      <AvailabilityScreen kind="offline" retry={() => void session.refetch()} />
    )
  if (session.isPending)
    return (
      <main>
        <PareLoading variant="fullscreen" label="กำลังตรวจสอบเซสชัน…" />
      </main>
    )
  if (session.isError) {
    const kind = failureKind(session.error)
    if (kind === 'expired')
      return (
        <AvailabilityScreen
          kind="expired"
          retry={() => void session.refetch()}
        />
      )
    return (
      <AvailabilityScreen
        kind="unavailable"
        retry={() => void session.refetch()}
      />
    )
  }
  if (!session.data) return <Navigate to="/login" />
  if (expired)
    return (
      <AvailabilityScreen kind="expired" retry={() => void session.refetch()} />
    )
  return children
}
